module.exports = __webpack_public_path__ + "media/images/homepage/luxury-4cfaac35b622a51cb9492b18d7cbc91b.jpg";